import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { LabelM } from 'atoms/typography';
import { ellipsis } from 'atoms/typography/Ellipsis';
import { PageHeader } from 'components/navigation/PageHeader';
import { Avatar } from 'components/user/Avatar';
import { ANY_SPORT_MY_CLUB } from 'constants/routes';
import { useCurrentUserContext } from 'contexts/currentUser';
import { useSportContext } from 'contexts/sport';

const StyledLink = styled(Link)`
  display: flex;
  gap: var(--unit);
  align-items: center;
`;

const Nickname = styled(LabelM)`
  ${ellipsis}
`;

export const ProfilePageHeader = () => {
  const { currentUser } = useCurrentUserContext();
  const { generateSportContextPath } = useSportContext();

  if (!currentUser) {
    return null;
  }

  return (
    <PageHeader disableBackBrowser>
      <StyledLink
        to={generateSportContextPath(ANY_SPORT_MY_CLUB, {
          params: {
            slug: currentUser.slug,
          },
        })}
      >
        <Avatar user={currentUser} size={5} rounded />
        <Nickname bold>{currentUser.nickname}</Nickname>
      </StyledLink>
    </PageHeader>
  );
};
